export function createConverter() {
    return {
        toFirestore: function (data) { return data; },
        fromFirestore: function (snapshot, options) { return snapshot.data(options); },
    };
}
export default createConverter;
